<div class="image-wrapper event-card" [class.active]="active" [title]="hoverText">
  <img class="media-image event-thumbnail" [src]="getThumbSource()" />
  @if (isVideo) {
    <span>
      <mat-icon>play_circle_outline</mat-icon>
    </span>
  }
  @if (hoverText) {
    <div class="event-title">{{ hoverText }}</div>
  }
</div>

